import { useRef, useState } from "react";
import { acdCodes } from "../../utils/acdCodes";
import moment from "moment";
import { actions, basis, dueProcess, extent, stagingState, suffix } from "../../utils/withdrawalOptions";
import { formatDOB, validateDate } from "../../components/consts/dateMask"
import { useNavigate } from "react-router-dom";
import { buildAddWithdrawal, buildUpdateFcwdDriverInfo, linkedConvictions, defaultDriverData, errMessage, foreignData, isNewUser, makeWithdrawalObjectForAdd, postJson, setDefaultDriverData, toYMD, setLinkedConvictions, isDown } from "../../utils/data";
import { generateReasonRefCode, generateWdLocatorRef } from "../../utils/data";
import { canadianProvinces, countryOptions, mexicanStates } from "../../utils/countryOptions";
import { useAuth } from "../../context/AuthContext";
import { withdrawalIssues } from "../../utils/messages";
import StateSel from "./selectQueries/stateSel.js";
import Loading from "../tabs/loading.js";


function AddWithdrawal() {

    //const {source, email} = useAuth();
    const {source, token, userState, email, roles} = useAuth();
    const acdDetailsRef = useRef(null);
    const navigate = useNavigate();
    const [extentCode, setExtentCode] = useState("");
    const [acdCode, setAcdCode] = useState("");
    const [selectedAcd, setSelectedAcd] = useState();
    const [selectedDueProcess, setDueProcess] = useState("");
    const [indefPerm, setIndefPerm] = useState("");
    const [selectedBasis, setBasis] = useState("");
    const [action, setAction] = useState("");
    const [comments, setComments] = useState("Withdrawal Added");
    const [stateNative, setStateNative] = useState("");
    const [locator, setLocator] = useState("");
    const [reinstatementDate, setReinstatementDate] = useState("");
    const [eligibilityDate, setEligibilityDate] = useState("");
    const [effectiveDate, setEffectiveDate] = useState("");
    const [firstName, setFirstName] = useState(defaultDriverData.firstName);
    const [middleName, setMiddleName] = useState(defaultDriverData.middleName);
    const [surName, setSurName] = useState(defaultDriverData.surName);
    const [selectedSuffix, setSelectedSuffix] = useState(defaultDriverData.suffix);
    const [jurisdiction, setJurisdiction] = useState('');
    const [dob, setDob] = useState(defaultDriverData.dob);
    const [street1, setStreet1] = useState(defaultDriverData.street1);
    const [street2, setStreet2] = useState(defaultDriverData.street2);
    const [city, setCity] = useState(defaultDriverData.city);
    const [county, setCounty] = useState(defaultDriverData.county);
    const [state, setState] = useState(defaultDriverData.state);
    const [stateStyle, setStateStyle] = useState(null);
    const [zip, setZip] = useState(defaultDriverData.zip);
    const [country, setCountry] = useState('');
    const [driverState, setDriverState] = useState('');
    const [driverLicense, setDriverLicense] = useState(defaultDriverData.driverLicense);
    const [sex, setSex] = useState(defaultDriverData.sex);
    const [maxVal , setMaxVal] = useState(0);
    const [newUser, setNewUser] = useState({});
    const [ dateErr, setDateErr ] = useState([]);
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState();
    const [err, setErr] = useState([]);
    const screenRef = useRef(null);
    const errRef = useRef(null);
    //const userState =  "CA" //convictions.JurisdictionCodeConvicting;// Example user state, replace with actual user logic

    const userType = "DEFAULT"; // Replace with actual user state logic
    const dataSource = {DataSource: source, CAorMXDown: isDown, userId: email}


  const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
  }

  const handleSetDob = () => {
     let dp = new Date().toISOString().split('T')[0];
    const [y,m,d] = dp.split('-');
    const yn = y - 21;
    const ny = yn+'-'+m+'-'+d; 
    setDob(ny)
  }

    const handleCountryOptions = (e) => {
        const {value} = e.target;
        setCountry(value);
        switch (value){
            case 'CA':
                setStateStyle(canadianProvinces);
                break;
            case 'MX':
                setStateStyle(mexicanStates);
                break;
            case 'US':
                setStateStyle(stagingState);
                break;
            default:
                setStateStyle(null);
                break
        }
    }

    const handleAcdChange = (e) => {
        const code = e.target.value; // Reset ACD Details input
        setAcdCode(code);
        console.log(`Selected ACD Code: ${code}`);
        if (acdDetailsRef.current) {
            acdDetailsRef.current.value = ""; // clear the input field
        }
        code === "S92" ? setMaxVal(5) : 
        code.startsWith("D") ? setMaxVal(3) :
        setMaxVal(2);
        const found = acdCodes.find(a => a.code === code);
        setSelectedAcd(found || null);
    }

    const  handleCancel = (e) => {
        e.preventDefault();
        navigate(-1);
    }

    const handleSubmit = async (e) => {
        setLoading(true);
        setErr('');
        e.preventDefault();
        let errs = [];
        const form = e.target;
        setDateErr(err)
        window.scrollTo(0, 0);

        validateDate(dob, true, errs);
        validateDate(effectiveDate, false, errs);
        validateDate(eligibilityDate, false, errs);
        validateDate(reinstatementDate, false, errs);


        if(errs.length > 0){
            setDateErr(errs);

        }

        if (form.checkValidity() === false) {
        e.stopPropagation(); // prevent submit if invalid
        setLoading(false);
        } else {
            console.log("Selected ACD", selectedAcd.linkageReq, linkedConvictions.length);
            // if(linkedConvictions.length === 0 && selectedAcd.linkageReq){
            //     setErr(<><div style={{color:'red'}}>Linkage needed for ACD Code {acdCode}</div></>)
            // } else{
                console.log("Submit in progress", )
                const convictions = linkedConvictions
                console.log("Selected Convictions", convictions);
                const withdrawal = {
                    JurisdictionCodeWithdrawing: jurisdiction !== '' ? jurisdiction: userState,
                    DriverLicenseWithdrawalEffectiveDate: effectiveDate,
                    DriverLicenseWithdrawalType: action,
                    DriverLicenseWithdrawalBasis: selectedBasis,
                    DLWithdrawalDueProcessStatus: selectedDueProcess,
                    DRVLicAcdWithdrawalReasonCode: acdCode,
                    DRVLicWithdrawalEligibilityDate: indefPerm === '' ? eligibilityDate : indefPerm.toUpperCase(),
                    DLWithdrawalReinstatementDate: reinstatementDate,
                    DRVLicWithdrawalExtentIdDlc: extentCode,
                    DLWithdrawalJurisdictionReportId: locator,
                    DRVLicWithdrawalReasonReference: stateNative,
                    WithdrawalCategory: "",
                    WithdrawalNoticePeriod: "",
                    WithdrawalDuration: "",
                    WithdrawalDQLetterMailedDate: "",
                    WithdrawalReinstLetterSentDate: "",
                    WithdrawalDisqLetterNeeded: "",
                    WithdrawalDisqLetterSentDate: "",
                    WithdrawalStatusNotes: comments,
                    WithdrawalUserId: email,
                    WithdrawalDateReceived: moment().format("YYYYMMDD"),
                    WithdrawalDatePosted: moment().format("YYYYMMDD"),
                }
                console.log("C: "+JSON.stringify(linkedConvictions))
                console.log("W: "+JSON.stringify(withdrawal))
                const issues = withdrawalIssues(withdrawal, linkedConvictions);
                if (issues.length) {
                    setErr(issues.map((m, i) => <div key={i} style={{color:'red'}}>{m}</div>));
                    setLoading(false);
                    return; // prevent POST if validation fails
                }
                if(isNewUser){
                    setDefaultDriverData({
                    PersonDetails:{
                        PersonName:{SurName:surName, FirstName:firstName, MiddleName: middleName, Suffix: selectedSuffix},
                        DOB: dob,
                        MailingAddress:{Line1: street1, Line2:street2, City:city, County:county, State:state, Zip:zip, Country:country}
                    },

                    License:{JurisdictionOfIssue: defaultDriverData.driverState, LicenseNumber: defaultDriverData.driverLicense}
                    });
                    await postJson('/api/driver/update', buildUpdateFcwdDriverInfo({driver: defaultDriverData, sourceOpts: dataSource}), null, token)
                    .then(function(res) {
                        console.log("Results", res);
                    })
                    .catch(function(error) {
                        setErr("Error Updating User: "+error.message);
                    });
                }
                
                const build = buildAddWithdrawal({driver: defaultDriverData, foreign: foreignData, convictions: convictions, withdrawal: withdrawal, sourceOpts: dataSource})
                console.log("Have request for add Withdrawal", build);
                await postJson('/api/withdrawal/add', build, null, token)
                .then(function(response) {
                    console.log("Response sent")
                    if (response.Status === "SUCCESS"){
                        setErr()
                        setLinkedConvictions([]);
                        navigate(-1);
                    }
                    setErr(response.Messages[0])
                })
                .catch(function(error) {
                    setErr("Error submitting Withdrawal: "+error.message);
                });
            // }
        }
        setLoading(false);
        setValidated(true); 
    }
  
      return (
          <>
              <div className="App">
                {/* <div style={{color: 'red'}}>{dateErr}</div> */}
                <div style={{color: 'red'}}>{err}</div>
                <div ref={screenRef}></div>
                <div>{errMessage}</div>
                {loading &&
                        <Loading />}
                  <h1>Add Withdrawal</h1>
                  <div id="table">
                      <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
                          <div className="row">
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver State</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  value={defaultDriverData.driverState} disabled />
                              </div>
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver License</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  value={defaultDriverData.driverLicense} disabled />
                              </div>
                          </div>

                          {isNewUser &&
                          <><div className="row" style={{borderBottom: '1px solid black', marginBottom: '20px'}}>
                              <div className="col-md-3">
                                  <label className="form-label"><b>Driver First Name</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setFirstName(e.target.value)}
                                  value={firstName} />
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b>Driver Middle Name</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setMiddleName(e.target.value)}
                                  value={middleName} />
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Driver Last Name</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setSurName(e.target.value)}
                                  value={surName} required/>
                                  <div className="invalid-feedback">Please enter Last Name</div>
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b>Suffix</b></label>
                                  <select className="form-select"
                                      onChange={(e) => setSelectedSuffix(e.target.value)}
                                      value={selectedSuffix}
                                  >
                                    <option value=""> -- Suffix -- </option>
                                        {suffix.map((val) => (
                                            <option value={val}>{val}</option>
                                        ))}
                                  </select>
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Date of Birth </b></label>
                                      <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" name='DOB' 
                                      onClick={handleSetDob}
                                      onKeyDown={(e) => disableKey(e)}
                                      onChange={(e) => setDob(e.target.value).format("YYYYMMDD")}
                                      value={moment(dob).format("YYYY-MM-DD")}
                                      max={moment().format("YYYY-MM-DD")}
                                      min="1"
                                      required />
                                    <div className="invalid-feedback">Please enter a Date of Birth</div>
                              </div>
                          </div>
                          <th>Residence</th>
                          <div className="row" style={{borderBottom: '1px solid black', marginBottom: '20px'}}>
                            <div className="col-md-3">
                                  <label className="form-label"><b>Street Address 1</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setStreet1(e.target.value)}
                                  value={street1} />
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b>Street Address 2</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setStreet2(e.target.value)}
                                  value={street2} />
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b>City</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setCity(e.target.value)}
                                  value={city} />
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b>County</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setCounty(e.target.value)}
                                  value={county} />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label"><b>Country</b></label>
                                <select className="form-select" aria-label=".form-select-lg example"   
                                    value={country}
                                    onChange={handleCountryOptions}
                                >
                                    <option value=""> -- Country -- </option>
                                    <option value="US">(US) US - United States</option>
                                    {Object.values(countryOptions).flat().map((opt) => (
                                        <option key={opt.code} value={opt.code}>
                                        {opt.label}
                                        </option>
                                    ))}
                                </select>
                              </div>
                              <div className="col-md-3">
                                  {country !== 'CA' ? 
                                  <label className="form-label"><b>State</b></label>
                                  :
                                  <label className="form-label"><b>Providence</b></label>}
                                  {stateStyle === null ?
                                  (<input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setState(e.target.value)}
                                  value={state} />)
                                  :
                                  <select className="form-control form-select" aria-label=".form-select-lg example"
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}>
                                        <option value= "" disabled> -- select an option -- </option>
                                        {stateStyle.map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                            {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                }
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b>Zip</b></label>
                                  <input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setZip(e.target.value)}
                                  value={zip} />
                              </div>
                          </div>
                          
                          <th>Withdrawal</th></>}
                          <div className="row">
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Effective Date </b></label>
                                <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" name='effectiveDate'
                                      onKeyDown={(e) => disableKey(e)}
                                      value={effectiveDate}
                                      onChange={(e) => setEffectiveDate(e.target.value)}
                                      required />
                                    <div className="invalid-feedback">Please enter a valid Effective Date</div>
                              </div>
                              {indefPerm !== null && indefPerm === "" ? 
                                <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Eligible Date</b></label>
                                   <input type="date" className="form-control"
                                      placeholder="MM/DD/YYYY" name='eligibilityDate'
                                      onKeyDown={(e) => disableKey(e)}
                                      value={eligibilityDate}
                                      onChange={(e) =>  setEligibilityDate(e.target.value)}
                                      required />
                 
                                      <div className="invalid-feedback">Please enter a valid Eligible Date</div>
                              </div> :
                              <div className="col-md-3">
                                  <label className="form-label"><b>Withdrawal Eligible Date</b></label>
                                <input type="date" className="form-control" 
                                      value=""
                                      placeholder="MM/DD/YYYY" name='eligibilityDate'
                                      onKeyDown={(e) => disableKey(e)}
                                      readOnly />
                                </div>}
                              
                              <div className="col-md-3">
                                  <label className="form-label"><b>Indef/Perm</b></label>
                                  <select className="form-select"
                                      value={indefPerm}
                                      onChange={(e) => setIndefPerm(e.target.value)}
                                  >
                                      <option value="">-- INDEF/PERM --</option>
                                      <option value="indef">INDEF</option>
                                      <option value="perm">PERM</option>
                                  </select>
                              </div>
                          </div>
  
                          <div className="row">
                            <div className="col-md-3">
                                  <label className="form-label"><b>Withdrawal Reinstated Date</b></label>
                                  <input type="date" className="form-control" 
                                     onKeyDown={(e) => disableKey(e)}
                                     value={reinstatementDate}
                                     onChange={(e) => setReinstatementDate(e.target.value)}
                                     max={moment().format("YYYYMMDD")}
                                      placeholder="MM/DD/YYYY" name='convictionDate'/>
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Action</b></label>
                                  <select className="form-select"
                                      value={action}
                                      onChange={(e) => setAction(e.target.value)}
                                       required >
                                        <option value="" disabled>-- Action --</option>
                                      {actions[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select an Action</div>
                                </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Basis</b></label>
                                  <select className="form-select"
                                      value={selectedBasis}
                                      onChange={(e) => setBasis(e.target.value)}
                                       required
                                  >
                                      <option value="" disabled>-- Basis --</option>
                                      {basis[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select a Basis</div>
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Due Process</b></label>
                                  <select className="form-select"
                                      value={selectedDueProcess}
                                      onChange={(e) => setDueProcess(e.target.value)}
                                       required
                                  >
                                      <option value="" disabled>-- Due Process --</option>
                                      {dueProcess[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select a Due Process</div>
                              </div>
                              
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> ACD Code</b></label>
                                    <select className="form-select"
                                        value={acdCode}
                                        onChange={handleAcdChange}
                                         required
                                    >
                                        <option value="" disabled>-- ACD Code --</option>
                                        {acdCodes.map((opt) => (
                                            <option key={opt.code} value={opt.code} title={opt.label}>
                                                {opt.code} - {opt.simple}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">Please select an ACD Code</div>
                                </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Extent Code</b></label>
                                  <select className="form-select"
                                      value={extentCode}
                                      onChange={(e) => setExtentCode(e.target.value)}
                                       required
                                  >
                                      <option value="" disabled>-- Extent Code --</option>
                                      {extent[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select an Extent Code</div>
                              </div>
                              {source === "HelpDesk" &&
                                <div className="col-md-3">
                                    <label className="form-label mt-2"><b><span className="text-danger">*</span> Withdrawal Jurisdiction</b></label>
                                    <select className="form-select"
                                        value={jurisdiction}
                                        onChange={(e) => setJurisdiction(e.target.value)}
                                        required
                                        >
                                            <option value="" disabled>-- Jurisdiction --</option>
                                            <option value="FH">FH</option>
                                            {stagingState.map((opt) => (
                                                <option key={opt.code} value={opt.code}>
                                                    {opt.code}
                                                </option> ))}
                                        </select>
                                  <div className="invalid-feedback">Please select a Withdrawal Jurisdiction</div>
                                </div>
                            }
                          </div>
                          <div className="row">
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Locator Number</b></label>
                                  <input autoComplete="off" type="text" className="form-control" name="locator" 
                                  value={locator}
                                  onChange={(e) =>setLocator(e.target.value)}
                                  maxLength={18}  required />
                                  <div className="invalid-feedback">Please enter a Withdrawal Locator Number</div>
                              </div>
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span> State Native Code</b></label>
                                  <input autoComplete="off" type="text" className="form-control" name="stateNative"
                                  value={stateNative}
                                  onChange={(e)=>setStateNative(e.target.value)}
                                  maxLength={8}  required />
                                  <div className="invalid-feedback">Please enter a State Native Code</div>
                              </div>
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span> Comments</b></label>
                                  <input autoComplete="off" type="text" className="form-control"
                                  value={comments}
                                  onChange={(e) => setComments(e.target.value)}
                                  name="comments" maxLength={500}  required />
                              </div>
                                <div className="invalid-feedback">Please provide comments for the audit file.</div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                                <label className="form-label"><b>Withdrawal Posted Date</b></label>
                                <input autoComplete="off" type="date" className="form-control" 
                                    placeholder="MM/DD/YYYY" 
                                    name='postedDate'    
                                    onKeyDown={(e) => disableKey(e)}        
                                    value={moment().format("YYYY-MM-DD")}
                                    disabled />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label"><b>User ID</b></label>
                                <input autoComplete="off" type="text" className="form-control"
                                value={email}
                                name="userId" disabled />
                            </div>
                        </div>
                          <button type="submit" className="btn btn-primary mt-3">
                            Add Withdrawal
                          </button>
                          <button type="button" onClick={(e) => handleCancel(e)} 
                          className="btn btn-secondary mt-3 ms-2">
                            Back to Details for DL:{defaultDriverData.driverLicense}
                          </button>
                      </form>
                  </div>
                  {linkedConvictions.length > 0 &&
                          <table className="table table-striped table-bordered">
        <thead style={{width: '100%'}}>
            <tr>
                <th scope="col">Select</th>
                <th scope="col">Citation Date</th>
                <th scope="col">Conv Date</th>
                <th scope="col">Conv ID</th>
                <th scope="col">SOC</th>
                <th scope="col">Court Type</th>
                <th scope="col">ACD</th>
                <th scope="col">Detail</th>
                <th scope="col">CDL</th>
                <th scope="col">CMV</th>
                <th scope="col">Haz Mat</th>
                <th scope="col">Conv Offense Loc</th>
                <th scope="col">State Native Code</th>
                <th scope="col">Category</th>
                <th scope="col">User ID</th>
                <th scope="col">Date Posted</th>
            </tr>
        </thead>
        <tbody>
          {linkedConvictions.map(conviction => (
            <tr>
                
                <td><input type="checkbox" aria-label="Checkbox for following text input" checked disabled/></td>
                <td id="cCitationDate">{conviction.CitationDate}</td>
                <td id="cConvDate">{conviction.ConvictionDate}</td>
                <td id="convID">{conviction.ConvictionIdCode}</td>
                <td id="SOC">{conviction.JurisdictionCodeConvicting}</td>
                {conviction.ConvictionCourtType !== "" && conviction.ConvictionCourtType.split('-')[1] ? <td id="cCourt">{conviction.ConvictionCourtType.split('-')[1]}</td> : <td id="cCourt">{conviction.ConvictionCourtType}</td>}
                <td id="cACD">{conviction?.ConvictionOffenseAcdCode?.Code}</td>
                <td id="cDetail">{conviction.ConvictionOffenseDetailAcd}</td>
                {conviction.CitationCdlHolderIndicator !== "" && conviction.CitationCdlHolderIndicator.split('-')[1] ? <td id="cCDL">{conviction.CitationCdlHolderIndicator.split('-')[1]}</td> : <td id="cCDL">{conviction.CitationCdlHolderIndicator}</td>}
                {conviction.ConvictionCommercialVehInd !== "" && conviction.ConvictionCommercialVehInd.split('-')[1] ? <td id="CMV">{conviction.ConvictionCommercialVehInd.split('-')[1]}</td> : <td id="CMV">{conviction.ConvictionCommercialVehInd}</td>}
                {conviction.ConvictionHazmatInd !== "" && conviction.ConvictionHazmatInd.split('-')[1] ? <td id="cHazmat">{conviction.ConvictionHazmatInd.split('-')[1]}</td> : <td id="cHazmat">{conviction.ConvictionHazmatInd}</td>}
                <td id="cConvOff">{conviction.ConvictionJurisCourtReportId}</td>
                <td id="cStateNative">{conviction.ConvictionJurisdictionOffenseCode}</td>
                <td id="cCategory">{conviction.ConvictionCategory}</td>
                <td id="cUserID">{conviction.ConvictionUserID}</td>
                <td id="cDatePosted">{conviction.ConvictionDatePosted}</td>
                
            </tr>
            ))}
            

        </tbody>
        </table>}
              </div>
  
              {/* Modal for ACD Info */}
              {selectedAcd && (
                  <div className="modal fade" id="acdInfoModal" tabIndex="-1" aria-labelledby="acdInfoModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                          <div className="modal-content">
                              <div className="modal-header">
                                  <h5 className="modal-title" id="acdInfoModalLabel">ACD Code Information</h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div className="modal-body">
                                  <p><strong>ACD Code:</strong> {selectedAcd.code}</p>
                                  <p><strong>Description:</strong> {selectedAcd.label}</p>
                                  {selectedAcd.validation && (
                                      <p><strong>Validation:</strong> {selectedAcd.validation}</p>
                                  )}
                                  {selectedAcd.moreInfo && (
                                      <p><strong>More Info:</strong> {selectedAcd.moreInfo}</p>
                                  )}
                              </div>
                              <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                              </div>
                          </div>
                      </div>
                  </div>
              )}
          </>
      );
}

export default AddWithdrawal;